import React from "react";
import HeroBanner from "../components/HeroBanner";
import PromotionalBanner from "../components/PromotionalBanner";
import ContactForm from "../components/ContactForm";
import { Box, Typography } from "@mui/material";

export default function LandingPage() {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        
      </Typography>
      <HeroBanner />
      <Box sx={{ mt: 4 }}>
        <PromotionalBanner />
      </Box>
      <Box sx={{ mt: 4 }}>
        <ContactForm />
      </Box>
    </Box>
  );
}